// Output type values (must match backend enum when API is wired)
export const OUTPUT_TYPES = {
  PIN: 'PIN',
  SWITCH_INDICATOR: 'SWITCH_INDICATOR',
  ECP: 'ECP',
  NA: 'N/A',
}

// Input type values
export const INPUT_TYPES = {
  SWITCH: 'SWITCH',
  NA: 'N/A',
}

// Human-readable labels for output types
export const OUTPUT_TYPE_LABELS = {
  [OUTPUT_TYPES.PIN]: 'Pin',
  [OUTPUT_TYPES.SWITCH_INDICATOR]: 'Switch Indicator',
  [OUTPUT_TYPES.ECP]: 'ECP',
  [OUTPUT_TYPES.NA]: 'N/A',
}

// Human-readable labels for input types
export const INPUT_TYPE_LABELS = {
  [INPUT_TYPES.SWITCH]: 'Switch',
  [INPUT_TYPES.NA]: 'N/A',
}

// Human-readable labels for output types shown in the output tile (side panel)
export const OUTPUT_TILE_LABELS = {
  ...OUTPUT_TYPE_LABELS,
  [OUTPUT_TYPES.PIN]: 'Pin Output',
}

// SelectMenu options for output type
export const OUTPUT_TYPE_OPTIONS = [
  {
    key: OUTPUT_TYPES.PIN,
    value: OUTPUT_TYPES.PIN,
    title: OUTPUT_TYPE_LABELS[OUTPUT_TYPES.PIN],
  },
  {
    key: OUTPUT_TYPES.SWITCH_INDICATOR,
    value: OUTPUT_TYPES.SWITCH_INDICATOR,
    title: OUTPUT_TYPE_LABELS[OUTPUT_TYPES.SWITCH_INDICATOR],
  },
  {
    key: OUTPUT_TYPES.ECP,
    value: OUTPUT_TYPES.ECP,
    title: OUTPUT_TYPE_LABELS[OUTPUT_TYPES.ECP],
  },
  {
    key: OUTPUT_TYPES.NA,
    value: OUTPUT_TYPES.NA,
    title: OUTPUT_TYPE_LABELS[OUTPUT_TYPES.NA],
  },
]

// SelectMenu options for input type
export const INPUT_TYPE_OPTIONS = [
  {
    key: INPUT_TYPES.SWITCH,
    value: INPUT_TYPES.SWITCH,
    title: INPUT_TYPE_LABELS[INPUT_TYPES.SWITCH],
  },
  {
    key: INPUT_TYPES.NA,
    value: INPUT_TYPES.NA,
    title: INPUT_TYPE_LABELS[INPUT_TYPES.NA],
  },
]

// Maximum number of outputs per fast feature
export const MAX_OUTPUTS = 5

// 35M code identifiers shown as individual dropdowns per output
export const CODES_35M = [
  '35M-010',
  '35M-011',
  '35M-012',
  '35M-013',
  '35M-014',
  '35M-015',
]

// Maps an output type to the key in availableOptions that holds its details
export const OUTPUT_TYPE_TO_OPTIONS_KEY = {
  [OUTPUT_TYPES.PIN]: 'pins',
  [OUTPUT_TYPES.SWITCH_INDICATOR]: 'indicators',
  [OUTPUT_TYPES.ECP]: 'solenoids',
}

// Filter options for the Fast Feature Filter form
export const FILTER_OUTPUT_OPTIONS = [
  { value: '2A', label: '2A' },
  { value: '5A', label: '5A' },
  { value: '20A', label: '20A' },
  { value: 'ECP', label: 'ECP' },
]

// Factory to build a fresh empty output object
export const buildEmptyOutput = (outputNumber) => ({
  outputNumber,
  outputType: null,
  outputDetail: null,
  inputType: null,
  inputDetail: null,
  codes35M: CODES_35M.reduce((acc, code) => ({ ...acc, [code]: null }), {}),
})

export const buildInitialOutputs = (count = MAX_OUTPUTS) =>
  Array.from({ length: count }, (_, i) => buildEmptyOutput(i + 1))
